import React, { useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheckCircle, faTimesCircle, faSpinner } from "@fortawesome/free-solid-svg-icons";
import { Col, Row, Card, Button, Container, Alert, Image } from '@themesberg/react-bootstrap';
import { Link, useLocation, useHistory } from 'react-router-dom';

import { Routes } from "../../routes";
import BgImage from "../../assets/img/illustrations/signin.svg";
import ProductivosLogo from "../../assets/img/productivos-logo.png";
import api from "../../api/api";

export default () => {
    const location = useLocation();
    const history = useHistory();
    const [status, setStatus] = useState('loading'); // 'loading', 'success', 'error'
    const [message, setMessage] = useState('');

    useEffect(() => {
        const confirmUser = async () => {
            // Extract the code from URL query parameters
            const params = new URLSearchParams(location.search);
            const code = params.get('code');

            if (!code) {
                setStatus('error');
                setMessage('No se proporcionó un código de confirmación válido.');
                return;
            }

            try {
                // Call the confirmation API endpoint
                const response = await api.get('/api/user/confirm', {
                    params: { code }
                });

                setStatus('success');
                setMessage(response.data || '¡Tu cuenta ha sido confirmada exitosamente!');
            } catch (error) {
                console.error('Confirmation error:', error);
                setStatus('error');

                // Extract error message from API response
                let errorMessage = 'No se pudo confirmar tu cuenta. El enlace puede haber expirado o ser inválido.';

                if (error.response?.data) {
                    // If the response is a string, use it directly
                    if (typeof error.response.data === 'string') {
                        errorMessage = error.response.data;
                    } else if (error.response.data.message) {
                        errorMessage = error.response.data.message;
                    }
                }

                setMessage(errorMessage);
            }
        };

        confirmUser();
    }, [location]);

    // Auto-redirect to login after 5 seconds on success
    useEffect(() => {
        if (status === 'success') {
            const timer = setTimeout(() => {
                history.push(Routes.Signin.path);
            }, 5000);

            return () => clearTimeout(timer);
        }
    }, [status, history]);

    const handleRedirectToLogin = () => {
        history.push(Routes.Signin.path);
    };

    return (
        <main>
            <section className="d-flex align-items-center my-5 mt-lg-6 mb-lg-5">
                <Container>
                    <Row className="justify-content-center form-bg-image" style={{ backgroundImage: `url(${BgImage})` }}>
                        <Col xs={12} className="d-flex align-items-center justify-content-center">
                            <div className="bg-white shadow-soft border rounded border-light p-4 p-lg-5 w-100 fmxw-500">
                                <div className="text-center text-md-center mb-4 mt-md-0">
                                    <Image src={ProductivosLogo} alt="Productivos.org" style={{ height: '60px', marginBottom: '20px' }} />
                                    <h3 className="mb-0">Confirmación de Registro</h3>
                                </div>

                                {status === 'loading' && (
                                    <div className="text-center py-5">
                                        <FontAwesomeIcon icon={faSpinner} spin size="3x" className="text-primary mb-3" />
                                        <p className="text-muted">Confirmando tu cuenta...</p>
                                    </div>
                                )}

                                {status === 'success' && (
                                    <>
                                        <Alert variant="success" className="text-center">
                                            <FontAwesomeIcon icon={faCheckCircle} size="3x" className="mb-3 d-block" />
                                            <h5 className="mb-3">¡Confirmación Exitosa!</h5>
                                            <p className="mb-0">{message}</p>
                                        </Alert>

                                        <div className="mt-4">
                                            <Button
                                                variant="primary"
                                                className="w-100"
                                                onClick={handleRedirectToLogin}
                                            >
                                                Ir al Inicio de Sesión
                                            </Button>
                                        </div>

                                        <div className="text-center mt-3">
                                            <p className="text-muted small">
                                                Serás redirigido automáticamente en 5 segundos...
                                            </p>
                                        </div>
                                    </>
                                )}

                                {status === 'error' && (
                                    <>
                                        <Alert variant="danger" className="text-center">
                                            <FontAwesomeIcon icon={faTimesCircle} size="3x" className="mb-3 d-block" />
                                            <h5 className="mb-3">Error en la Confirmación</h5>
                                            <p className="mb-0">{message}</p>
                                        </Alert>

                                        <div className="mt-4">
                                            <Button
                                                variant="primary"
                                                className="w-100"
                                                onClick={handleRedirectToLogin}
                                            >
                                                Volver al Inicio de Sesión
                                            </Button>
                                        </div>

                                        <div className="text-center mt-3">
                                            <p className="text-muted small">
                                                Si el problema persiste, por favor contacta al soporte.
                                            </p>
                                        </div>
                                    </>
                                )}

                                {status === 'success' && (
                                    <div className="d-flex justify-content-center align-items-center mt-4">
                                        <span className="fw-normal">
                                            ¿Necesitas ayuda?
                                            <Card.Link as={Link} to={Routes.Signup.path} className="fw-bold">
                                                {` Crear nueva cuenta `}
                                            </Card.Link>
                                        </span>
                                    </div>
                                )}
                            </div>
                        </Col>
                    </Row>
                </Container>
            </section>
        </main>
    );
};
